import request from '@/api/index'

export function login(data) {
    return request({
        url: '/login/',
        method: 'post',
        data
    })
}

export function getLoginInfo(params) {
    return request({
        url: '/login_mess/',
        method: 'get',
        params
    })
}


export function addAdmin(data) {
    return request({
        url: '/admin/add/',
        method: 'post',
        data
    })
}

export function getAdminList(params) {
    return request({
        url: '/admin/list/',
        method: 'get',
        params
    })
}

export function delAdmin(data) {
    return request({
        url: '/admin/del/',
        method: 'post',
        data
    })
}

export function getWxSignature(data) {
    return request({
        url: '/util/jssdk/',
        method: 'post',
        data,
    })
}